// 导入发送验证码接口
import {
		sendMsgCode
	} from "@/api/user.js"

const sendCode = {
    data() {
        return {
            send: false, //验证码是否发送
            times: 60, //倒计时
			key:'key',
			sence:''
        }
    },
    methods: {
        //获取验证码
        sendTextCode(mobile) {
            if (this.send) {
                return this.$message.error('60s内不能重复发送！')
            } else {
                if (mobile) {
                    let judge = this.judgeMobile(mobile)
                    if (judge) {
                        // todo...
                        this.doSendCode(mobile)
                       
                    } else {
                        return this.$message.error('请填写正确手机号！')
                    }
                } else {
                    return this.$message.error('请先填写手机号！')
                }
            }
        },
        // 发送验证码接口
        doSendCode(mobile) {
            let params = {
                phone:mobile,
				code:this.sence
            }
            sendMsgCode(params).then(res =>{
				this.key=res.data.id
				
				this.$message.success('验证码已发送至' + mobile + '~')
				this.send = true
				this.timer = setInterval(() => {
				    if (this.times > 0 && this.times <= 60) {
				        this.times--
				    } else {
				        this.times = 60
				        this.send = false
				        clearInterval(this.timer)
				    }
				}, 1000)
            })
        },
        // 判断手机号
        judgeMobile(mobile) {
            return /^1[23456789]\d{9}$/.test(mobile)
        }
    }
}

export default sendCode
